import { X, Coffee, TrendingUp, Star } from 'lucide-react';

interface LoyaltyInfoSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const tiers = [
  { name: 'Гость', percent: '10%', threshold: null, color: 'text-text-muted' },
  { name: 'Друг', percent: '12%', threshold: '5 000₽', color: 'text-blue-400' },
  { name: 'Близкий Друг', percent: '15%', threshold: '15 000₽', color: 'text-yellow-400' },
  { name: 'Легенда', percent: '20%', threshold: '30 000₽', color: 'text-purple-400' },
];

export function LoyaltyInfoSheet({ isOpen, onClose }: LoyaltyInfoSheetProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fade-in"
        onClick={onClose}
      />

      {/* Sheet */}
      <div className="relative w-full max-w-lg bg-card rounded-t-[24px] p-6 pb-8 animate-slide-up shadow-2xl border-t border-border">
        {/* Handle */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-10 h-1 rounded-full bg-text-muted/30" />

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 rounded-full text-text-muted hover:text-text-main transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Content */}
        <div className="mt-4 space-y-5">
          {/* Section 1 */}
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Coffee className="w-5 h-5 text-primary" />
              <h3 className="text-lg font-bold text-text-main">Копите баллы — получайте подарки</h3>
            </div>
            <p className="text-sm text-text-muted leading-relaxed">
              За каждый заказ мы начисляем вам баллы. Тратьте их на любимые напитки
              и десерты из раздела «Награды». Всё просто: 1 балл&nbsp;=&nbsp;1₽.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <TrendingUp className="w-5 h-5 text-primary" />
              <h3 className="text-lg font-bold text-text-main">Чем больше вы с нами — тем выгоднее</h3>
            </div>
            <p className="text-sm text-text-muted leading-relaxed mb-4">
              Ваш уровень растёт вместе с вами. Чем больше вы тратите,
              тем щедрее становятся начисления — автоматически, без лишних действий.
            </p>

            {/* Tiers table */}
            <div className="space-y-2">
              {tiers.map((tier) => (
                <div
                  key={tier.name}
                  className="flex items-center justify-between rounded-xl bg-secondary/10 px-4 py-3 border border-border/50"
                >
                  <div className="flex items-center gap-2">
                    <Star className={`w-4 h-4 ${tier.color}`} />
                    <span className="font-semibold text-text-main text-sm">{tier.name}</span>
                  </div>
                  <div className="text-right">
                    <span className="font-bold text-primary text-sm">{tier.percent}</span>
                    {tier.threshold && (
                      <span className="text-xs text-text-muted ml-1.5">от {tier.threshold}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
